import { Component, input } from '@angular/core';

@Component({
  selector: 'app-progress',
  styleUrl: './progress.component.scss',
  templateUrl: './progress.component.html',
})
export class ProgressComponent {
  public readonly steps = input<string[]>([]);

  private currentStep: number;

  constructor() {
    this.reset();
  }

  public get progress() {
    return this.currentStep + 1;
  }

  public reset() {
    this.currentStep = 0;
  }

  back() {
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  }

  public next() {
    if (this.currentStep < this.steps().length - 1) {
      this.currentStep++;
    }
  }

  protected get progressStyle(): any {
    const percent = (this.currentStep / (this.steps().length - 1)) * 100;
    return { width: percent + '%' };
  }

  protected isActive(index: number): boolean {
    return this.currentStep >= index;
  }

  protected canSetCurrentStep(index: number) {
    return index >= 0 && index < this.currentStep;
  }

  protected setCurrentStep(index: number) {
    if (!this.canSetCurrentStep(index)) {
      return;
    }

    this.currentStep = index;
  }
}
